import Icon from '../components/Icon.vue'

Icon.register({"tags":{"width":640,"height":512,"paths":[{"d":"M497.9 225.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V252.1A48-48 0 0 1 14.1 286.1L225.9 497.9C244.7 516.7 275.1 516.7 293.8 497.9L497.9 293.8C516.7 275.1 516.7 244.7 497.9 225.9zM112 160C85.5 160 64 138.5 64 112S85.5 64 112 64 160 85.5 160 112 138.5 160 112 160zM625.9 293.8L421.8 497.9C403.1 516.7 372.7 516.7 353.9 497.9L353.6 497.6 527.6 323.5C544.6 306.5 554 283.9 554 259.9S544.6 213.2 527.6 196.2L331.4 0H380.1A48-48 0 0 0 414.1 14.1L625.9 225.9C644.7 244.7 644.7 275.1 625.9 293.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tags.js
// module id = Sxjo
// module chunks = 0